import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const scheduleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSchedules: builder.query({
      query: query => {
        const qs = query ? `?${new URLSearchParams(query).toString()}` : '';
        return `schedule${qs}`;
      },
      providesTags: ['Schedule'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSchedulesQuery,
} = scheduleApi;
